import React from 'react';

import TrashBin from '@gravity-ui/icons/TrashBin';
import { Button, Icon, TextInput } from '@gravity-ui/uikit';
import { Field } from 'client/blocks/form/Field/Field';
import { withForm } from 'client/blocks/form/formHook';

import styles from './AliceExternalAppEditPage.module.scss';
import { emptyDomainEntry, ExternalFormState } from './AliceExternalAppForm.types';

/**
 * Editable list of CSP domain entries — one TextInput per item, with add/remove controls.
 *
 * Uses TanStack-form's `withForm` so the parent passes a typed `form` reference (no `any` casts
 * on `name`/`handleChange`). Each row carries a client-side `id` so React keys stay stable when
 * an item is removed — using the array index instead would shift state onto the wrong DOM nodes.
 */
export const DomainListField = withForm({
    defaultValues: {} as ExternalFormState,
    props: {
        name: '' as `resources[${number}].meta.cspConnectDomains` | `resources[${number}].meta.cspResourceDomains`,
        title: '',
        addLabel: '',
        disabled: false,
    },
    render: ({ form, name, title, addLabel, disabled }) => (
        <form.Field name={name} mode="array">
            {(field) => (
                <Field fieldTitle={title} containerClassName={styles.compactField} size="m">
                    {field.state.value.map((entry, i) => (
                        <form.Field key={entry.id} name={`${name}[${i}].value` as const}>
                            {(sub) => (
                                <div className={styles.domainRow}>
                                    <TextInput
                                        value={sub.state.value}
                                        onUpdate={sub.handleChange}
                                        disabled={disabled}
                                        size="m"
                                        placeholder="https://example.com"
                                    />
                                    <Button view="flat" disabled={disabled} onClick={() => field.removeValue(i)}>
                                        <Icon data={TrashBin} />
                                    </Button>
                                </div>
                            )}
                        </form.Field>
                    ))}
                    <Button view="flat" disabled={disabled} onClick={() => field.pushValue(emptyDomainEntry())}>
                        + {addLabel}
                    </Button>
                </Field>
            )}
        </form.Field>
    ),
});
